<body class="d-flex flex-column vh-100 position-relative">
    <div class="appBodyWrapper d-flex h-100 flex-fill flex-column">
        <div class="appHeader position-relative">
           <div class="overly"></div>
              <div class="container position-relative z-3 px-0">
                <!-- <nav class="navbar navbar-expand-lg bg-transparent p-0 flex-nowrap">
                    <a class="navbar-brand d-inline-flex" href="#">
                        <span>
                            <img src="./assets/images/profile_img.svg" alt="profile_img" class="img-fluid" width="33px" height="33px" />
                        </span>
                    </a>
                    <div class="ms-auto justify-content-end" id="navbarNav">
                        <ul class="ms-auto navbar-nav flex-nowrap flex-row">
                            <li class="nav-item">
                                <a class="nav-link py-0 px-0" href="#" >
                                    <span>
                                        <img src="./assets/images/card.svg" alt="card" class="img-fluid" width="33px" height="33px" />
                                    </span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link py-0 px-2" href="#" >
                                    <span>
                                        <img src="./assets/images/notification.svg" alt="card" class="img-fluid" width="33px" height="33px" />
                                    </span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link py-0 px-0" href="#" >
                                    <span>
                                        <img src="./assets/images/help_support.svg" alt="card" class="img-fluid" width="33px" height="33px" />
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </nav> -->

                <div class="banner mt-3">

                    <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="true">
                        <!-- <div class="carousel-indicators mb-0">
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                        </div> -->
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <img src="./assets/images/instacardImgedited.png" class="d-block w-100" alt="EMI-card" />
                            </div>
                            <div class="carousel-item">
                                <img src="./assets/images/instacardImgedited.png" class="d-block w-100" alt="EMI-card" />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="appbody h-100">
            <div class="container">
                <div class="congra text-center">
                    <h2 class="fs-14 fw-semibold mb-3 pb-1">Hi Now Apply for Instacard and get a pre approved credit limit upto</h2>
                    <h2 class="fs-34 text-green mb-3 pb-1 fw-bold"  style="font-family: 'Figtree'!important" >₹ 1,00,000</h2>
                    <div class="flex-item">
                        <a (click)="availNow()" class="btn btn-primary fs-14 fw-semibold rounded-pill py-1 px-4">
                            <span>Apply Now</span>
                        </a>
                    </div>
                </div>
                 <div class="credit-limit available bg-white card card-body mb-4">
                    <!-- <div class="d-flex align-items-center justify-content-between flex-wrap">
                         <div class="flex-item">
                            <h2 class="fs-20 fw-bold text-black m-0">₹ 1,00,000</h2>
                        </div> 
                        <div class="flex-item">
                            <a href="#" class="btn btn-primary fs-14 fw-semibold rounded-pill py-1 px-4">
                                <span>Avail Now</span>
                            </a>
                        </div>
                    </div> -->
                </div> 
                <div class="card card-body border-0 bg-transparent p-0 mb-4 text-center">
                    <h3 class="fs-6 fw-medium lh-1 text-545454 mb-3 pb-1">Benefits & Features</h3>
                    <ul class="list-unstyled list-icon mb-0 text-center">
                        <li>
                            <div class="d-flex align-items-center ">
                                <div class="icon">
                                    <img src="./assets/images/Pre_Approved_Loan.png" alt="img" class="img-fluid">
                                </div>
                                <div class="title">
                                    <p class="mb-0 text-323232 fs-14 fw-medium ">Pre-approved loan* up to ₹ 1 lakh</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="d-flex align-items-center">
                                <div class="icon">
                                    <img src="./assets/images/Repay_Easily.png" alt="img" class="img-fluid">
                                </div>
                                <div class="title">
                                    <p class="mb-0 text-323232 fs-14 fw-medium">Repay easily</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="d-flex align-items-center">
                                <div class="icon">
                                    <img src="./assets/images/No_Documentation.png" alt="img" class="img-fluid">
                                </div>
                                <div class="title">
                                    <p class="mb-0 text-323232 fs-14 fw-medium">No documentation</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="d-flex align-items-center">
                                <div class="icon">
                                    <img src="./assets/images/Zero_Cost_EMI.png" alt="img" class="img-fluid">
                                </div>
                                <div class="title">
                                    <p class="mb-0 text-323232 fs-14 fw-medium">Zero Cost EMI*</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="d-flex align-items-center">
                                <div class="icon">
                                    <img src="./assets/images/Zero_Proc_Fee.png" alt="img" class="img-fluid">
                                </div>
                                <div class="title">
                                    <p class="mb-0 text-323232 fs-14 fw-medium">Zero Processing Fee</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
     </div>
</body>
